'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Usługa jest obecnie niedostępna, spróbuj ponownie później.',
    NEED_ACTIVE: 'Twoje konto {{account}} używa tej witryny po raz pierwszy. {{activeLink}}, aby zakończyć aktywację i powrócić do tej strony, aby kontynuować',
    GOTO_ACTIVE: 'Aktywuj teraz',
    NOT_ACTIVED: 'Konto nie zostało pomyślnie aktywowane, {{activeLink}}, aby zakończyć aktywację',
    COMPLETE_ACTIVE: 'Potwierdź aktywację',
    FORBID_ACTIVE: 'Konto nie jest obsługiwane w AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Zaloguj się za pomocą innego konta',
    ACTIVE_PAGE: 'Odwiedź stronę aktywacji konta'
};